/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import styles from '../../../styles/partials/more-info.scss';

const propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            id: PropTypes.string,
            defaultMessage: PropTypes.string,
        }),
    ]),
    link: PropTypes.string,
    color: PropTypes.string,
};

const defaultProps = {
    label: {
        id: 'content.more_info',
        defaultMessage: 'More info',
    },
    link: '#',
    color: null,
};

const inner = label => (
    <div>
        <span className={styles.label}>
            {isString(label) ? label : <FormattedMessage {...label} />}
        </span>
        <span className={styles.icon} />
    </div>
);

const MoreInfo = ({ label, link, color }) =>
    (link !== null ? (
        <Link
            to={link}
            className={classNames({ [styles.container]: true, [styles[color]]: color !== null })}
        >
            {inner(label)}
        </Link>
    ) : (
        <div className={classNames({ [styles.container]: true, [styles[color]]: color !== null })}>
            {inner(label)}
        </div>
    ));

MoreInfo.propTypes = propTypes;
MoreInfo.defaultProps = defaultProps;

export default MoreInfo;



// WEBPACK FOOTER //
// ./js/components/partials/MoreInfo.jsx